import { composeHOCs } from "@shared/common";
import { onChangeHoc } from "../../Hoc/onChangeHoc";
import { withValueSetHoc } from "../../Hoc/withValueSetHoc";
import { withHideOnFieldHoc } from "../../Hoc/withHideOnFieldHoc";
import { withSetFocusHoc } from "../../Hoc/withSetFocusHoc";

export const withFormFieldHoc = composeHOCs(
  withSetFocusHoc,
  withHideOnFieldHoc,
  withValueSetHoc,
  onChangeHoc
);
